import React, {useEffect} from 'react'
import {setLogContext} from '@vanguard/logger'

import {useAuth} from '../../stores/AuthStore'
import {LoadingState} from '../../components'

export const LoginView: React.FC<React.PropsWithChildren> = () => {
  setLogContext('LoginView')

  const {loginWithIdp} = useAuth()

  useEffect(() => {
    loginWithIdp()
  }, [loginWithIdp])

  return <LoadingState />
}
